export class Message { 
    public deleteQuestion = "¿Está segur@ que desea eliminar el registro?"
    public success = "Se ha procesado correctamente";
    public required = "* Campo requerido";
    public pattern = "incorrect@";
    public email = "incorrecto";
    public lengthMin = "No cumple con el minimo de caracteres";
    public lengthMax = "No cumple con el minimo de caracteres";
    public min = "minimo";
    public max = "maximo";
    public Response0 = "No se ha podido conectar con el servidor";
    public Response201 = "Se ha guardado exitosamente";
    public Response204 = "No hay contenido";
    public Response400 = "Solicitud Incorrecta";
    public Response401 = "Solicitud no autorizada";
    public Response403 = "Recurso Prohibido";
    public Response404 = "No se encontraron datos";
    public Response500 = "Error en el servidor";
    
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/config/message.ts